export default {
    organizationView: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organization/:id'
    },
    organizationCreate: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organization/create'
    },
    organizationUpdate: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organization/:id'
    },
    organizationsIndex: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organizations',
    },
    organizationsIndexDeleted: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organizations/deleted',
    },
    restoreOrganization: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organization/restore/:id',
    },
    deleteOrganization: {
        method: 'GET',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/organizations/delete/:id',
    },
    usersForHQManagers: {
        method: 'POST',
        url: process.env.VUE_APP_API_URL + '/api/v1/hierarchy/userProfilesAutoComplete'
    },
}